export const PO_COMPLETE_DOCUMENT_SELECTED_DEVICE_FEE_TABLE_CELL_WIDTH = 150;

export const PO_COMPLETE_DOCUMENT_DEVICE_FEES_FIRST_PAGE_TABLE_ROW_LENGTH = 24;
export const PO_COMPLETE_DOCUMENT_DEVICE_FEES_OTHER_PAGE_TABLE_ROW_LENGTH = 30;
export const PO_COMPLETE_DOCUMENT_DEVICE_FEES_TABLE_NAME_CELL_WIDTH = 180;
export const PO_COMPLETE_DOCUMENT_DEVICE_FEES_TABLE_QTY_CELL_WIDTH = 40;
export const PO_COMPLETE_DOCUMENT_DEVICE_FEES_TABLE_PRICE_CELL_WIDTH = 90;
